import {AsyncCacheMap} from "@app/common/helpers/async-cache-map/async-cache-map"
import {TypedImageData} from "@cm/utils"
import {ImageColorSpace, DataObject} from "@cm/utils/data-object"
import {firstValueFrom, from, Observable} from "rxjs"
import {DataObjectContentCache} from "@app/template-editor/helpers/data-object-content-cache"

export class ImageDataCache extends AsyncCacheMap<string, TypedImageData, DataObject> {
    constructor(private dataObjectContentCache: DataObjectContentCache) {
        super((_, dataObject: DataObject) => {
            const loadImageBuffer = async (dataObject: DataObject): Promise<TypedImageData> => {
                const buffer = await firstValueFrom(this.dataObjectContentCache.evaluateDataObject(dataObject))
                const blob = new Blob([buffer as Uint8Array<ArrayBuffer>], {type: dataObject.mediaType})

                const imageBitmap = await createImageBitmap(blob)

                const canvas = document.createElement("canvas")
                canvas.width = imageBitmap.width
                canvas.height = imageBitmap.height
                const ctx = canvas.getContext("2d")
                if (!ctx) throw new Error("Canvas 2D context not available")

                ctx.drawImage(imageBitmap, 0, 0)

                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)

                const typedImageData: TypedImageData = {
                    data: imageData.data,
                    dataType: "uint8",
                    width: imageData.width,
                    height: imageData.height,
                    channelLayout: "RGBA",
                    colorSpace: dataObject.imageColorSpace === ImageColorSpace.Srgb ? "sRGB" : "linear",
                }

                return typedImageData
            }

            return from(loadImageBuffer(dataObject))
        })
    }

    evaluateImageData(dataObject: DataObject): Observable<TypedImageData> {
        return this.get(dataObject.downloadUrl, dataObject)
    }
}
